import React, { Component } from "react";
import { Nav } from "react-bootstrap";
import "./Menu.scss";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser, faNewspaper, faSearch, faGlobeAmericas } from "@fortawesome/free-solid-svg-icons";

export default class Menu extends Component {

    render() {
        return (
            <Nav
                className="fixed-bottom"
                activeKey="/home"
                id="menu-footer"
            >
                <Nav.Item>
                    <NavLink to="/newsfeed">
                        <FontAwesomeIcon icon={faNewspaper} />
                    </NavLink>
                </Nav.Item>
                <Nav.Item>
                    <NavLink to="/explore">
                        <FontAwesomeIcon icon={faGlobeAmericas} />
                    </NavLink>
                </Nav.Item>
                <Nav.Item>
                    <NavLink to="/searchUser">
                        <FontAwesomeIcon icon={faSearch} />
                    </NavLink>
                </Nav.Item>
                <Nav.Item>
                    <NavLink to="/profile">
                        <FontAwesomeIcon icon={faUser} />
                    </NavLink>
                </Nav.Item>
            </Nav>
        );
    }
}